import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import AdminSidebar from "../layouts/AdminSidebar";
import { Trash, Plus } from "react-bootstrap-icons";
import { handleNumericInput } from "../util/utils";
import { authCall } from "../../services";
import ImageUploads from "../util/ImageUploads";

const COMPANYTYPE = [
  { value: "1", label: "Booking", name: "booking" },
  { value: "2", label: "Restaurant", name: "dinning" },
  { value: "3", label: "Nightlife", name: "nightlife" },
];

function RecommendPositionsPage() {
  const today = moment().format("YYYY-MM-DD");
  const [loading, setLoading] = useState(false);
  const { current } = useSelector((state) => state.user);
  const [loadingSubs, setLoadingSubs] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [companies, setCompanaies] = useState([]);
  const [selectedOption, setSelectedOption] = useState(COMPANYTYPE[0]);

  const initialField = [];
  Array(6)
    .fill()
    .forEach((_, index) => {
      initialField.push({
        id: index + 1,
        company: "All Companies",
        activity: "",
        activityList: [],
        amount: "",
      });
    });
  const [dailyDeals, setDailyDeals] = useState(initialField);

  const getDealDetails = async () => {
    setLoading(true);
    const resp = await authCall("getDailyDeals", {});
    const deals = [];
    if (resp?.type === "success") {
      resp?.payload.forEach(async (el, index) => {
        deals.push({
          id: index,
          dailyDealId: el.id,
          date: el.deal_date,
          company: el.company,
          activityId: el.activity_id,
          activity: el.activity,
          activityList: [],
          priceOne: el.prize_one,
          priceOneQuantity: el.prize_one_quantity,
          priceTwo: el.prize_two,
          priceTwoQuantity: el.prize_two_quantity,
          priceThree: el.prize_three,
          priceThreeQuantity: el.prize_three_quantity,
          priceOneRemainQuantity: el.prize_one_quantity_remain,
          priceTwoRemainQuantity: el.prize_two_quantity_remain,
          priceThreeRemainQuantity: el.prize_one_quantity_remain,
          voucherImage: el.voucher,
        });
      });
      // setDailyDeals(deals);
      setLoading(false);
    }
  };

  const getCompanies = async (type) => {
    const resp = await authCall("getSearchList", {
      type: type,
    });
    if (resp?.type === "success") {
      setCompanaies(resp?.payload?.details);
    }
  };

  const getCompanyActivities = async (companyName) => {
    const resp = await authCall("getCompanyActivities", {
      companyName: companyName,
    });

    if (resp?.type === "success") {
      return resp?.payload?.details?.map((e) => ({
        ...e,
        label: e.activity_name,
      }));
    } else {
      return [];
    }
  };

  useEffect(() => {
    getDealDetails();
    getCompanies("booking");
  }, []);

  const addDeal = () => {
    const newFields = [];
    newFields.push({ ...initialField, id: dailyDeals.length + 1 });
    setDailyDeals([...dailyDeals, ...newFields]);
  };

  const handleChangePlan = (id, name, value) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id ? { ...field, [name]: value } : field
      )
    );
  };

  const handleChangeQuantity = (id, name, value) => {
    const inputValue = handleNumericInput(value);
    if (inputValue !== null && inputValue.length < 5) {
      setDailyDeals(
        dailyDeals.map((field) =>
          field.id === id ? { ...field, [name]: inputValue } : field
        )
      );
    }
  };

  const handleSubmit = async () => {
    console.log("ddd", dailyDeals);
    return;
    toast.dismiss();
    // setLoadingSubs(`loading${item.id}`);
    // const values = {
    //   userId: current.id,
    //   dailyDealId: item?.dailyDealId || "",
    //   date: item.date,
    //   company: item.company,
    //   activityId: item.activityId,
    //   activity: item.activity,
    //   priceOne: item.priceOne,
    //   priceOneQuantity: item.priceOneQuantity,
    //   priceTwo: item.priceTwo,
    //   priceTwoQuantity: item.priceTwoQuantity,
    //   priceThree: item.priceThree,
    //   priceThreeQuantity: item.priceThreeQuantity,
    //   voucherImage: item.isItemPhotoUploaded ? item.voucherImage : "",
    // };
    // const resp = await authCall("dailyDeals", values);
    // if (resp?.type === "success") {
    //   setLoadingSubs("");
    //   toast.success(resp?.message);
    // } else {
    //   setLoadingSubs("");
    //   toast.error(resp?.message);
    // }
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
          disabled={loadingDelete || false}
        >
          {loadingDelete ? "Loading..." : "Yes"}
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    if (el.dailyDealId) {
      const resp = await authCall("deleteDailyDeal", {
        dailyDealId: el.dailyDealId,
        isSoft: true,
      });
      setLoadingDelete(true);
      if (resp?.type === "success") {
        closeToast();
        toast.success(resp?.message);
        setLoadingDelete(false);
        getDealDetails();
      } else {
        toast.error(resp?.message);
        setLoadingDelete(false);
      }
    } else {
      setDailyDeals(dailyDeals.filter((e) => e.id !== el.id));
      closeToast();
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleChangeComapny = async (id, selected) => {
    const activitiesList = await getCompanyActivities(selected);
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, company: selected, activitiesList: activitiesList }
          : field
      )
    );
  };

  const handleChangeActivity = (id, selected) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, activityId: selected.id, activity: selected }
          : field
      )
    );
  };

  const getItemPhoto = (id) => (img) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, voucherImage: img, isItemPhotoUploaded: true }
          : field
      )
    );
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    getCompanies(selected?.name);
  };

  return (
    <>
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Recommend Position</div>

                {/* daily deals */}
                <div className="details-wrapper">
                  <Row className="align-items-center mb-4 mt-2">
                    <Col xs={4}>
                      <span className="fs-sm">Company Type:</span>
                      <Select
                        className="text-body mt-1"
                        placeholder="Select"
                        value={selectedOption}
                        onChange={handleChange}
                        options={COMPANYTYPE}
                      />
                    </Col>
                  </Row>

                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div className="row gx-3 d-flex flex-wrap align-items-center mb-1">
                          <div className="col-1">
                            <label
                              htmlFor="RestaurantPhone"
                              className="fs-md-16 mb-2 text-custom-primary"
                              style={{ fontWeight: 700 }}
                            >
                              S.No.
                            </label>
                          </div>
                          <div className="col-4">
                            <label
                              htmlFor="RestaurantPhone"
                              className="fs-md-16 mb-1 text-custom-primary"
                              style={{ fontWeight: 700 }}
                            >
                              {selectedOption?.label === "Booking" && "Company"}
                              {selectedOption?.label === "Restaurant" &&
                                "Restaurant"}
                              {selectedOption?.label === "Nightlife" && "Venue"}
                            </label>
                          </div>
                          {selectedOption?.label === "Booking" && (
                            <div className="col-4">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-1 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Activities
                              </label>
                            </div>
                          )}
                          <div className="col-3">
                            <label
                              htmlFor="RestaurantPhone"
                              className="fs-md-16 mb-2 text-custom-primary"
                              style={{ fontWeight: 700 }}
                            >
                              Prize
                            </label>
                          </div>
                        </div>

                        {!loading &&
                          dailyDeals.map((field, index) => (
                            <div key={index}>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-1">
                                  <div
                                    disabled
                                    type="text"
                                    className="form-control"
                                    style={{ textAlign: "center" }}
                                  >
                                    {index + 1}
                                  </div>
                                </div>
                                <div className="col-4">
                                  <Select
                                    className="text-body mt-1"
                                    placeholder="Select"
                                    value={{
                                      label: field?.company,
                                      name: field?.company,
                                    }}
                                    onChange={(e) =>
                                      handleChangeComapny(
                                        field.id,
                                        e?.company_name
                                      )
                                    }
                                    options={companies}
                                  />
                                </div>
                                {selectedOption?.label === "Booking" && (
                                  <div className="col-4">
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={field.activity}
                                      onChange={(e) =>
                                        handleChangeActivity(field.id, e)
                                      }
                                      options={field?.activitiesList}
                                    />
                                  </div>
                                )}
                                <div className="col-3">
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.amount}
                                    name="amount"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        <div className="row gx-3 d-flex flex-wrap align-items-center mb-3 mt-5">
                          <div className="col-4"></div>
                          <div className="col-4">
                            <div className="d-flex align-items-center">
                              <button
                                type="button"
                                style={{
                                  height: 40,
                                  width: "50%",
                                  zIndex: 0,
                                }}
                                className="btn btn-custom btn-custom-sm fs-16"
                                onClick={handleSubmit}
                                disabled={loadingSubs || false}
                              >
                                {loadingSubs ? "Loading..." : "Update"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RecommendPositionsPage;
